export const displayName = (value) => ({
  type: 'DISPLAY_NAME',
  payload: value,
});

export const customerSearchBoxLabel = (value) => ({
  type: 'CUSTOMER_SEARCH_BOX_LABEL',
  payload: value,
});

export const customerSearchBoxNote = (value) => ({
  type: 'CUSTOMER_SEARCH_BOX_NOTE',
  payload: value,
});

export const merchantLogo = (value) => ({
  type: 'MERCHANT_LOGO',
  payload: value,
});

export const minimumAcceptAmountForPayment = (value) => ({
  type: 'MINIMUM_ACCEPT_AMOUNT_FOR_PAYMENT',
  payload: value,
});

export const searchboxPlaceholderLabel = (value) => ({
  type: 'SEARCH_BOX_PLACEHOLDER_LABEL',
  payload: value,
});

export const andhraElectricityData = (value) => ({
  type: 'ANDHRA_ELECTRICITY_DATA',
  payload: value,
});